import { history } from '../App'
import { PagesPathEnum } from '../pages/enums/pages-path.enum'

export const navigateToPath = (path: PagesPathEnum): void => history.push(path)
